<script lang="ts">
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"
    import FormInputText from "../widgets/Form/FormInputText.svelte"
    import { postAccessToken } from "../../api"
    import { _ } from "svelte-i18n"
    import Index from "../SEO/Index.svelte"

    let email = $state("")
    let success = $state(false)
    let loading = $state(false)

    const submit = () => {
        loading = true
        postAccessToken({ email })
            .then(() => (success = true))
            .catch((e) => {
                console.log(e)
                alert($_("my-orders.error"))
            })
            .finally(() => (loading = false))
    }
</script>

<Index noIndex={true} title={$_("my-orders.my-orders")} metaDescription={$_("meta.description")} />
<section id="myOrdersPage" class="section-type-1 section_padding checkout">
    <div class="container">
        <h1>{$_("my-orders.my-orders")}</h1>
        <p>
            {@html $_("my-orders.link-request-intro-html")}
        </p>
        {#if success}
            <p>
                <b>{$_("my-orders.link-request-success")}</b>
            </p>
        {:else}
            <form
                class="orderform"
                onsubmit={(e) => {
                    e.preventDefault()
                    submit()
                }}
            >
                <div class="row">
                    <div class="col-md-6">
                        <FormInputText name="email" label="E-Mail" required bind:value={email} />
                    </div>
                    <div class="col-md-6">
                        {#if loading}
                            <BarLoader />
                        {:else}
                            <button type="submit" class="button primary">{$_("my-orders.send-link")}</button>
                        {/if}
                    </div>
                </div>
            </form>
        {/if}
    </div>
</section>

<style lang="less">
    @import "../../css/variables.less";

    .orderform {
        .button {
            height: 45px;
        }
    }
</style>
